import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { IApplicationState } from '../../../stateManagement/states/ApplicationState';
import * as fromRoot from '../../../stateManagement/rootReducer';
import { IToastr } from '../../types';
import { Router, ActivatedRoute } from '@angular/router';
import { DisableBusyFlag } from '../../../stateManagement/actions/containers/application';
import { DashboardService } from 'app/shared/services/dashboard.service';
import { DashboardSandbox } from 'app/shared/services/dashboard.sandbox';
import { DASHBOARD_ICON } from 'app/stage/types/constants';
@Component({
  selector: 'tr-dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.scss']
})
export class DashboardContainerComponent implements OnInit, OnDestroy {
  
  subscriptions: Array<Subscription> = []; 

  constructor(private store: Store<IApplicationState>, private router: Router, private route: ActivatedRoute, private service: DashboardService) {
    this.store.dispatch(new DisableBusyFlag({}));
    
    //this.subscriptions.push(this.route.queryParams.subscribe(params => this.errorCode = params['code'] || ''));
  }

  ngOnInit() {
  
  }

  getWelcomeMessage() {
    return this.service.getWelcomeMessage();
  }

  getStarters() {
    return this.service.getStarters()
  }

  getOffboarders() {
    return this.service.getOffboarders()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getCurrentStageInfo() {
      return DASHBOARD_ICON;
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/containers/dashboard-container/dashboard-container.component.ts